import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeriodFieldComponent } from '../..';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [PeriodFieldComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule
  ],
  exports: [PeriodFieldComponent],
  providers: [],
})
export class PeriodFieldModule { }
